module.exports = __webpack_public_path__ + "static/media/808-tom-01.994d1c49.wav";